import styled from 'styled-components';
import { SvgIcon } from '@make-software/cspr-ui';

export const InfoSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.contentTertiary,
  },
}));
